import React from "react";
import "./CircleScrollKartik.css";
import {
  FaGithub,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaUserAlt,
  FaWhatsapp,
  FaHackerrank,
} from "react-icons/fa";

const CircleScrollKartik = ({ devImg }) => {
  return (
    <div className="kartik__menuContainer">
      <nav className="kartik__menu">
        <input
          type="checkbox"
          href="#"
          name="kartik__menu-open"
          id="kartik__menu-open"
          className="kartik__menu-open"
        />
        <label className="kartik__menu-open-button" for="kartik__menu-open">
          <img className="devImage" src={devImg} alt="" />
        </label>
        <a
          href="https://www.facebook.com/kartik.jha.1217/"
          target="_blank"
          className="kartik__menu-item blue"
        >
          <FaFacebook />
        </a>
        <a
          href="whatsapp://send?abid=+918605640371&text=Hello%2C%20World!"
          className="kartik__menu-item green"
        >
          <FaWhatsapp />
        </a>
        <a
          href="https://www.instagram.com/lazy_illiterate_bernard/"
          target="_blank"
          className="kartik__menu-item red"
        >
          <i className="fa fa-heart">
            <FaInstagram />
          </i>
        </a>
        <a
          href="https://github.com/AlistairHeus/"
          target="_blank"
          className="kartik__menu-item black"
        >
          <i className="fa fa-microphone">
            <FaGithub />
          </i>
        </a>
        <a
          href="https://www.hackerrank.com/kartikjha13"
          target="_blank"
          className="kartik__menu-item lightgreen"
        >
          <i className="fa fa-star">
            <FaHackerrank />
          </i>
        </a>
        <a
          href="https://www.linkedin.com/in/kartik-jha-69165210a/"
          target="_blank"
          className="kartik__menu-item lightblue"
        >
          <i className="fa fa-diamond">
            <FaLinkedin />
          </i>
        </a>
      </nav>
    </div>
  );
};

export default CircleScrollKartik;
